import { Injectable } from '@angular/core';

@Injectable()
export class SettingsConstants {
  static readonly FAVORABLE = 1;
  static readonly UNFAVORABLE = 0;
  static readonly ASK_SON = 3;

  static readonly YES = 1;
  static readonly NO = 0;

  static readonly BASIC_REQUIREMENT = 1;
  static readonly BASIC_ADITIONAL = 2;

  static readonly ACM_OPTION = 1;
  static readonly EL_OPTION = 2;

  static readonly ACM_OPTION_TEXT = 'ACM';
  static readonly EL_OPTION_TEXT = 'EL';

  static readonly PARENT_SUPERIOR = 0;

  static readonly PARENT_EVALUATION_NO = 0;
  static readonly PARENT_EVALUATION_YES = 1;

  static readonly RESULT_ENTER = 0;
  static readonly RESULT_CHECK = 1;

  static readonly SET_ITEM_LEAF_AS_STRUCTURE_ROOT = 1;
  static readonly SET_ITEM_LEAF_WITH_LEAF_PARENT = 2;
  static readonly SET_ITEM_LEAF_WITH_PARENT_NODE = 3;
  static readonly SET_ITEM_PARENT_AS_STRUCTURE_ROOT = 4;
  static readonly SET_ITEM_PARENT_WITH_PARENT_NODE = 5;
  static readonly SET_ITEM_PARENT_WITH_LEAF_NODE = 6;
}
